<template>
  <div>
    <span v-if="title" class="item_title">{{ title }}<span v-if="tips" class="item_tips">{{ tips }}</span></span>
    <el-row :gutter="16">
      <template v-for="item in field">
        <el-col
          v-if="ignore(item)"
          :key="item.prop"
          :span="item.colSpan||8"
        >
          <el-form-item
            :label="item.label"
            :prop="item.ruleProp||item.prop"
            class="form_item"
            :rules="item.rules"
          >
            <template slot="label">
              <span>{{ item.label }}</span>
              <span v-if="item.labelTips" class="labelTips">{{ item.labelTips }}</span>
            </template>
            <slot
              v-if="item.slot"
              :name="item.slot"
              :scope="item"
            />
            <span v-else-if="item.type==='text'">
              <span v-if="item.textFormatter&&isHTML(item.textFormatter(form))" v-html="item.textFormatter(form)" />
              <span v-else>{{ item.textFormatter?item.textFormatter(form):form[item.prop] }}</span>
            </span>
            <template v-else>
              <component
                :is="componentType[item.formType]"
                v-model="form[item.prop]"
                v-bind="item.formAttributes"
              >
                <template v-if="item.subFormType&&item.subFormType==='el-option'">
                  <component
                    :is="item.subFormType"
                    v-for="option in item.options"
                    :key="option.value"
                    :value="option.value"
                    :label="option.label"
                    v-bind="item.subFormAttributes"
                  />
                </template>
                <template v-if="item.subFormType&&item.subFormType!=='el-option'">
                  <component
                    :is="item.subFormType"
                    v-for="option in item.options"
                    :key="option.value"
                    :label="option.value"
                    v-bind="item.subFormAttributes"
                  >
                    {{ option.label }}
                  </component>
                </template>
                <template v-if="item.formCustom&&item.formCustom.slot" :slot="item.formCustom.slot">
                  {{ item.formCustom.slotContent }}
                </template>
              </component>
            </template>
            <span v-if="item.tips" class="form_tips">{{ item.tips }}</span>
          </el-form-item>
        </el-col>
      </template>
    </el-row>
  </div>
</template>

<script>
import { isHTML } from '@/utils/index';

const componentType = {
  input: 'el-input',
  switch: 'el-switch',
  radio: 'el-radio-group',
  select: 'el-select',
  checkbox: 'el-checkbox-group',
  'date-picker': 'el-date-picker',
  'time-picker': 'el-time-picker',
};
export default {
  name: 'FormItem',
  props: {
    title: {
      type: String,
      default: '',
    },
    tips: {
      type: String,
      default: '',
    },
    form: {
      type: Object,
      default: () => {},
    },
    field: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      componentType,
      isHTML,
    };
  },
  computed: {
    ignore() {
      return (item) => {
        if (typeof item.isShow === 'boolean') {
          return item.isShow;
        }
        if (typeof item.isShow === 'function') {
          return item.isShow(this.form);
        }
        return true;
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.item_title{
  color: #323233;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  &::before{
    content:'';
    width: 3px;
    height: 16px;
    background-color: #059E84;
    margin-right: 8px;
  }
  .item_tips{
    margin-left: 8px;
    font-size: 12px;
    color: #808792;
  }
}

.form_item{
  display: flex;
  font-size: 14px;
  flex-direction: column;
  .el-form-item__label{
    color: #404B5C;
  }
  ::v-deep .el-form-item__content{
    margin-left: 0px !important;
    .el-input,.el-select{
      width: 100%;
    }
  }
  .el-radio-group{
    .el-radio{
      margin-right: 8px;
      margin-right: 0;
    }
  }
}
.form_tips{
  margin-left: 12px;
}
.labelTips {
  position: absolute;
  font-size: 12px;
  color: #7E8694;
  margin-left: 12px;
}
</style>
